import { useEffect, useMemo, useState } from 'react';

export const useValidatedState = (
  initialValue: string,
  test: ((value: string) => boolean) | RegExp,
) => {
  const [value, setter] = useState(initialValue);

  const isValid = useMemo(() => {
    if (typeof test === 'function') {
      return Boolean(test(value || ''));
    } else {
      return Boolean((value || '').match(test));
    }
  }, [value, test]);

  const [shouldIndicateInvalid, setShouldIndicateInvalid] = useState(false);

  useEffect(() => {
    setShouldIndicateInvalid(false);
  }, [value]);

  return [
    value,
    setter,
    isValid,
    !isValid && shouldIndicateInvalid,
    setShouldIndicateInvalid,
  ] as const;
};
